import { useEffect } from "react";
import { useParams, Navigate } from "react-router-dom";
import { useTenant } from "@/components/TenantProvider";
import { Loader2 } from "lucide-react";

/**
 * Handles `/t/:tenantSlug/*` routes.
 * TenantProvider already loaded the tenant branding from the URL.
 * This component simply redirects to the root path so the rest of the app
 * (login, dashboard, boards) renders normally, but with tenant branding
 * applied via CSS variables and the header logo swap.
 */
export default function TenantRedirect() {
  const { tenantSlug } = useParams();
  const { tenant, loading, error } = useTenant();

  // Persist which tenant the user is on across full-page reloads, in case
  // future navigations happen outside of /t/... paths.
  useEffect(() => {
    if (tenant?.slug) {
      try { sessionStorage.setItem("tenant_slug", tenant.slug); } catch {}
    }
  }, [tenant]);

  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center">
        <Loader2 className="h-6 w-6 animate-spin text-blue-500" />
      </div>
    );
  }

  if (error === "not_found") {
    return (
      <div className="min-h-screen grid place-items-center p-6 text-center">
        <div className="max-w-md">
          <h1 className="font-display text-2xl font-semibold">Espacio no disponible</h1>
          <p className="text-sm text-muted-foreground mt-2">
            El espacio <strong>{tenantSlug}</strong> no existe o fue desactivado.
          </p>
          <a href="/" className="inline-block mt-6 px-5 h-10 rounded-full bg-blue-600 text-white text-sm font-medium leading-10">
            Ir a Sprintroll
          </a>
        </div>
      </div>
    );
  }

  return <Navigate to="/" replace />;
}
